unit BudgetPeriodSetup;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, WEBLib.ExtCtrls, Vcl.StdCtrls,
  WEBLib.StdCtrls, XData.Web.Client;

type
  TfrmNewBudgetSetup = class(TForm)
    WebPanel1: TPanel;
    WebPanel2: TPanel;
    WebPanel3: TPanel;
    WebButton1: TButton;
    WebButton2: TButton;
    WebLabel1: TLabel;
    wcBudget: TXDataWebClient;
    sedBudget: TSpinEdit;
    procedure WebButton1Click(Sender: TObject);
  private
    { Private declarations }
  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  frmNewBudgetSetup: TfrmNewBudgetSetup;

implementation

{$R *.dfm}

uses
  stfmssystem.connection,
  share.common,
  share.classes;

procedure TfrmNewBudgetSetup.WebButton1Click(Sender: TObject);
var
  sJson : String;

  procedure OnError(Error: TXDataClientError);
    begin
      ShowMessage(Error.ErrorMessage);
    end;

  procedure OnSuccess(Response : TXDataClientResponse);
    begin
      If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
        begin
          ShowMessage('Error creating budget');
        end
      else
        begin
          ShowMessage('Successfully created');
          Close;
        end;
    end;
begin
  sJson := '{"Budget":'+IntToStr(sedBudget.Value)+',"User":"'+TAppSession.CurrentUser+'"}';
  wcBudget.RawInvoke('IdashboardService.Post_NewBudgetPeriod',[sJson],@OnSuccess,@OnError);
end;

procedure TfrmNewBudgetSetup.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel1 := TPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebPanel2 := TPanel.Create(Self);
  WebPanel3 := TPanel.Create(Self);
  WebButton1 := TButton.Create(Self);
  WebButton2 := TButton.Create(Self);
  sedBudget := TSpinEdit.Create(Self);
  wcBudget := TXDataWebClient.Create(Self);

  WebPanel1.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebPanel2.BeforeLoadDFMValues;
  WebPanel3.BeforeLoadDFMValues;
  WebButton1.BeforeLoadDFMValues;
  WebButton2.BeforeLoadDFMValues;
  sedBudget.BeforeLoadDFMValues;
  wcBudget.BeforeLoadDFMValues;
  try
    Name := 'frmNewBudgetSetup';
    Width := 640;
    Height := 258;
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 640;
    WebPanel1.Height := 258;
    WebPanel1.Align := alClient;
    WebPanel1.TabOrder := 0;
    WebLabel1.SetParentComponent(WebPanel1);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 208;
    WebLabel1.Top := 99;
    WebLabel1.Width := 141;
    WebLabel1.Height := 15;
    WebLabel1.Caption := 'Budget for the new period:';
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebPanel2.SetParentComponent(WebPanel1);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 0;
    WebPanel2.Top := 0;
    WebPanel2.Width := 640;
    WebPanel2.Height := 60;
    WebPanel2.Align := alTop;
    WebPanel2.Caption := 'Budget Setup';
    WebPanel2.Color := clSilver;
    WebPanel2.TabOrder := 0;
    WebPanel3.SetParentComponent(WebPanel1);
    WebPanel3.Name := 'WebPanel3';
    WebPanel3.Left := 0;
    WebPanel3.Top := 198;
    WebPanel3.Width := 640;
    WebPanel3.Height := 60;
    WebPanel3.Align := alBottom;
    WebPanel3.ChildOrder := 1;
    WebPanel3.Color := clSilver;
    WebPanel3.TabOrder := 1;
    WebButton1.SetParentComponent(WebPanel3);
    WebButton1.Name := 'WebButton1';
    WebButton1.Left := 8;
    WebButton1.Top := 16;
    WebButton1.Width := 96;
    WebButton1.Height := 25;
    WebButton1.Caption := 'Save';
    WebButton1.Color := clGreenyellow;
    WebButton1.HeightPercent := 100.000000000000000000;
    WebButton1.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton1, Self, 'OnClick', 'WebButton1Click');
    WebButton2.SetParentComponent(WebPanel3);
    WebButton2.Name := 'WebButton2';
    WebButton2.Left := 128;
    WebButton2.Top := 16;
    WebButton2.Width := 96;
    WebButton2.Height := 25;
    WebButton2.Caption := 'Cancel';
    WebButton2.Color := clRed;
    WebButton2.ChildOrder := 1;
    WebButton2.HeightPercent := 100.000000000000000000;
    WebButton2.WidthPercent := 100.000000000000000000;
    sedBudget.SetParentComponent(WebPanel1);
    sedBudget.Name := 'sedBudget';
    sedBudget.Left := 208;
    sedBudget.Top := 120;
    sedBudget.Width := 217;
    sedBudget.Height := 22;
    sedBudget.AutoSize := False;
    sedBudget.BorderStyle := bsSingle;
    sedBudget.ChildOrder := 3;
    sedBudget.Color := clWhite;
    sedBudget.Increment := 1;
    sedBudget.MaxValue := 100;
    sedBudget.MinValue := 0;
    sedBudget.Role := '';
    sedBudget.Value := 0;
    wcBudget.SetParentComponent(Self);
    wcBudget.Name := 'wcBudget';
    wcBudget.Connection := dmData.dbConnect;
    wcBudget.Left := 48;
    wcBudget.Top := 16;
  finally
    WebPanel1.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebPanel2.AfterLoadDFMValues;
    WebPanel3.AfterLoadDFMValues;
    WebButton1.AfterLoadDFMValues;
    WebButton2.AfterLoadDFMValues;
    sedBudget.AfterLoadDFMValues;
    wcBudget.AfterLoadDFMValues;
  end;
end;

end.